import React from "react";

const FriendsList = ({
  friendsList,
  loading,
  respondFriendRequest,
  removeFriend,
  handleOpenChat,
}) => {
  return (
    <div className="mt-6">
      <h3 className="text-xl font-semibold text-gray-800">Danh sách bạn bè</h3>
      {loading ? (
        <p className="text-center text-gray-500">Đang tải bạn bè...</p>
      ) : friendsList.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
          {friendsList.map((friend) => (
            <div
              key={friend.isPending ? `pending-${friend.requestId}` : `confirmed-${friend._id}`}
              className="border p-4 rounded-lg shadow"
            >
              <img
                src={friend.avatar || "https://placehold.co/100"}
                alt={friend.name}
                className="w-20 h-20 rounded-full mx-auto"
                onError={(e) => (e.target.src = "https://placehold.co/100")}
              />
              <p className="text-center mt-2">
                <strong>{friend.name}</strong>
              </p>
              <p className="text-center text-sm">
                {friend.locationText?.city}, {friend.locationText?.country}
              </p>
              {friend.isPending ? (
                <div className="flex justify-center gap-2 mt-2">
                  <button
                    onClick={() => respondFriendRequest(friend.requestId, "accept")}
                    className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    Chấp nhận
                  </button>
                  <button
                    onClick={() => respondFriendRequest(friend.requestId, "reject")}
                    className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    Hủy
                  </button>
                </div>
              ) : (
                <div className="flex justify-center gap-2 mt-2">
                  <button
                    onClick={() => handleOpenChat(friend._id)}
                    className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                    title="Chat"
                  >
                    <svg
                      className="w-4 h-4 mr-1"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
                    </svg>
                    Chat
                  </button>
                  <button
                    onClick={() => removeFriend(friend._id)}
                    className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    Hủy kết bạn
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">Bạn chưa có bạn bè nào.</p>
      )}
    </div>
  );
};

export default FriendsList;